import { render } from "./SelectBox.vue?vue&type=template&id=1d375b86&ts=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=1d375b86&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__